import { Component, OnInit, Input, ViewChild, ElementRef, NgZone} from '@angular/core';
import { FormControl } from '@angular/forms';
import { CnsltnReqModel,  CnsltnQuotRouteModel, ConsultSearchOption, NodeType, ModeType, FareService, GmapLogService} from '../../../../services/index';
import { Country, Address, CountryService, City, Location, Port, Airport, CityService, PortService, AirPortService, OceanLine, AirLine, OceanLineService, AirLineService} from '../../../../services/index';
import { MapsAPILoader } from '@agm/core';
import _ from 'lodash';
import { Subscription } from 'rxjs/Subscription';
declare var google:any;
declare var $:any;

@Component({
    selector:'fare-rate-detail-route-item',
    templateUrl: 'fare-rate-detail-route-item.html'
})

export class FareRateDetailRouteItem implements OnInit {

    @Input() itemTypes:Array<string> = ['city', 'port', 'air'];
    
    private _cnsltnQuotRoute: CnsltnQuotRouteModel;
    @Input() set cnsltnQuotRoute(cnsltnQuotRoute:CnsltnQuotRouteModel){
        if(!cnsltnQuotRoute) return;
        if(!cnsltnQuotRoute.location) cnsltnQuotRoute.location = new Location();

        this._cnsltnQuotRoute = cnsltnQuotRoute;
        this.ports = cnsltnQuotRoute.ports;
        this.airports = cnsltnQuotRoute.airports;
        this.countries = cnsltnQuotRoute.countries;

        //국가 셋팅
        if(cnsltnQuotRoute.cntryCd){
          this.setFilteredCountryList(cnsltnQuotRoute.cntryCd, true);
          if(this.filteredCountryList.length > 0){
            this.cntryListSelectHandler(this.filteredCountryList[0]);
          }
        }else if(cnsltnQuotRoute.location && cnsltnQuotRoute.location.cntryNm){
          this.setFilteredCountryList(cnsltnQuotRoute.location.cntryNm, true);
          if(this.filteredCountryList.length > 0){
            this.cntryListSelectHandler(this.filteredCountryList[0]);
          }
        }


        if(cnsltnQuotRoute.linerNm){
          if(cnsltnQuotRoute.typeCd == NodeType.PORT){
            this.onOceanLineInput(cnsltnQuotRoute.linerNm);
            if(this.filteredOceanLineList.length > 0){
              this.oceanLineListSelectHandler(this.filteredOceanLineList[0]);
            }
          }else if(cnsltnQuotRoute.typeCd == NodeType.AIRPORT){
            this.onAirLineInput(cnsltnQuotRoute.linerNm);
            if(this.filteredAirLineList.length > 0){
              this.airLineListSelectHandler(this.filteredAirLineList[0]);
            }
          }
        }
    }

    @Input() disabled = false;
    
    isCntryListOpen: boolean = false;
    focusedCntryIndex: number = 0;
    isPortCityListOpen: boolean = false;
    focusedLocationIndex: number = 0;

    isAirLineListOpen: boolean = false;
    focusedAirLineIndex: number = 0;
    isOceanLineListOpen: boolean = false;
    focusedOceanLineIndex: number = 0;
  
    selectedCntry:Country;
    selectedLocation:Location;
    selectedOceanLine:OceanLine;
    selectedAirLine:AirLine;
    selectedAddress:Address;
  
    countries: Array<Country> = [];
    ports: Array<Port> = [];
    airports: Array<Airport> = [];
  
    filteredCountryList: Array<Country> = [];
    cntryLocations = {
      city: [],
      port: [],
      airport: []
    };
    
    filteredPortAirCity: Array<any> = [];
    filteredOceanLineList: Array<any> = [];
    filteredAirLineList: Array<any> = [];
  
    countryControl: FormControl = new FormControl();
    portAirCityControl: FormControl = new FormControl();
    airLineControl: FormControl = new FormControl();
    oceanLineControl: FormControl = new FormControl();
    
    mapOptions = {
      fields: ["name", "geometry.location"],
      componentRestrictions: null
    };
    
    changeLinerEmitSub:Subscription;
    changeTransNmEmitSub:Subscription;
    
    constructor(
        private countryService: CountryService,
        private cityService: CityService,
        private portService: PortService,
        private airportService: AirPortService,
        private mapsAPILoader: MapsAPILoader, 
        private ngZone: NgZone,
        private fareServie: FareService,
        private oceanLineService: OceanLineService,
        private airLineService:AirLineService,
        private gmapLogService: GmapLogService
    ) {}
  
  
    @ViewChild("detailAddress")
    searchElementRef: ElementRef;
  
    @ViewChild("countryList")
    countryListElRef: ElementRef;
  
    @ViewChild("portAirCityList")
    portAirCityListElRef: ElementRef;
  
    @ViewChild("country")
    countryElRef: ElementRef;
  
    @ViewChild("portAirCity")
    portAirCityElRef: ElementRef;

    @ViewChild("airLineList")
    airLineListElRef: ElementRef;
    
    @ViewChild("oceanLineList")
    oceanLineListElRef: ElementRef;

    @ViewChild("airLine")
    airLineElRef: ElementRef;
  
    @ViewChild("oceanLine")
    oceanLineElRef: ElementRef;

    ngOnDestroy(){
      if(this.changeLinerEmitSub) this.changeLinerEmitSub.unsubscribe();
      if(this.changeTransNmEmitSub) this.changeTransNmEmitSub.unsubscribe();
    }

    ngOnInit() {
      this.changeLinerEmitSub = this.fareServie.changeLinerEmit.subscribe((data:any) =>{
        if(this._cnsltnQuotRoute.typeCd == NodeType.PORT){
          this.onOceanLineInput(data.linerNm);
          if(this.filteredOceanLineList.length > 0 && data.flag == 1){
            this.oceanLineListSelectHandler(this.filteredOceanLineList[0]);
          }
          if(data.flag == 0){
            this.isOceanLineListOpen = false;
          }
        }else if(this._cnsltnQuotRoute.typeCd == NodeType.AIRPORT){
          this.onAirLineInput(data.linerNm);
          if(this.filteredAirLineList.length > 0 && data.flag == 1){
            this.airLineListSelectHandler(this.filteredAirLineList[0]);
          }
          if(data.flag == 0){
            this.isAirLineListOpen = false;
          }
        }
      }); 

      this.changeTransNmEmitSub = this.fareServie.changeTransNmEmit.subscribe((data:any) =>{
        this._cnsltnQuotRoute.modeNm = data;
      });
    }
  
    setAutoComplete() {
      this.mapsAPILoader.load().then(() => {
        let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, this.mapOptions);
        this.gmapLogService.log('quot-add', 'PLACE');

        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            //get the place result
            let place = autocomplete.getPlace();
  
            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
  
            this.selectedAddress = new Address();
            this.selectedAddress.address = this.searchElementRef.nativeElement.value;
            this.selectedAddress.latitude = place.geometry.location.lat();
            this.selectedAddress.longitude = place.geometry.location.lng();
            
            this._cnsltnQuotRoute.locationAdrs = this.selectedAddress.address;
            this._cnsltnQuotRoute.latitude = this.selectedAddress.latitude;
            this._cnsltnQuotRoute.longitude = this.selectedAddress.longitude;

          });
        });
      });
    }
  
    setFilteredCountryList(event, isEqual?) {
      if (!event) return;
      
      let keyword = null;
      if(event.target) keyword = event.target.value;
      else keyword = event;
      
      if (!keyword) {
        if (this.selectedCntry) this.selectedCntry = null;
        if (this._cnsltnQuotRoute.location){
          this._cnsltnQuotRoute.location = new Location();
        }
         
        this.selectedLocation = null;
        this.selectedAddress = null;
        this.isCntryListOpen = false;
        return;
      }

      if(keyword.length > 0) {
        keyword = _.trim(_.upperCase(keyword));
            let filteredCountryList = _.map(_.filter(this.countries,
                                                                      (cntry) => {
                                                                          if (keyword.length <= 0) return true;
                                                                          else if (!isEqual && _.upperCase(cntry.cntryCd).indexOf(keyword) >= 0) return true;
                                                                          else if (!isEqual &&_.upperCase(cntry.cntryNm).indexOf(keyword) >= 0) return true;
                                                                          else if (isEqual &&_.upperCase(cntry.cntryCd) == _.upperCase(keyword)) return true;
                                                                          else if (isEqual &&_.upperCase(cntry.cntryNm) == _.upperCase(keyword)) return true;
                                                                          else return false;
                                    }));
        
        this.filteredCountryList = _.sortBy(filteredCountryList,
                                                                  (cntry) => {
                                                                    let nmIndex = _.upperCase(cntry.cntryNm).indexOf(keyword);
                                                                    let cdIndex = _.upperCase(cntry.cntryCd).indexOf(keyword);
                                                                      if (nmIndex < 0) nmIndex = 999;
                                                                      if (cdIndex < 0) cdIndex = 999;
                                                                      return _.min([nmIndex, cdIndex])
                                                                  });
                                                                  
        this.isCntryListOpen = true;
        this.focusedCntryIndex =  0;    
      } else {
        this.isCntryListOpen = false;
      }
  
      if(_.isEmpty(this.countryControl.value)) {
        this.portAirCityControl.setValue('');
      } 
    }
  
    checkCountryEmpty() {
      if(_.isEmpty(this.countryControl.value)) {
        $.sweetModal({
          content: "국가를 먼저 선택하세요.",
          icon: $.sweetModal.ICON_WARNING,
        });
      }
    }

    onPortAirCityInput(event) {
      if(_.isEmpty(this.countryControl.value)) {
        $.sweetModal({
          content: "국가를 먼저 선택하세요.",
          icon: $.sweetModal.ICON_WARNING,
        });
        return;
      };

      let val;
      if(event.target) val = event.target.value;
      else val = event;

      if (!val) {
        if (this.selectedLocation) this.selectedLocation = null;
        this.isPortCityListOpen = false;
        this._cnsltnQuotRoute.location.name = null;
        this._cnsltnQuotRoute.location.locationId = null;
        this._cnsltnQuotRoute.location.latitude = null;
        this._cnsltnQuotRoute.location.longitude = null;
        
        return;
      }
  
      if(val.length <= 1) {
        this.isPortCityListOpen = false;
      } else {
        this.isPortCityListOpen = true;
        let keyword = _.trim(_.upperCase(val));
        
        let filteredPortList = [];
        if (_.includes(this.itemTypes, 'port')) {
          filteredPortList = _.map(_.filter(this.cntryLocations.port,
                    (port) => {
                      if (keyword.length <= 0) return true;
                      else if (_.upperCase(port.portNm).indexOf(keyword) >= 0) return true;
                      else if (_.upperCase(port.portCd).indexOf(keyword) >= 0) return true;
                      else return false;
                    }));
  
          filteredPortList = _.sortBy(filteredPortList,
                (port) => {
                  let nmIndex = _.upperCase(port.portNm).indexOf(keyword);
                  let cdIndex = _.upperCase(port.portCd).indexOf(keyword);
                  if (nmIndex < 0) nmIndex = 999;
                  if (cdIndex < 0) cdIndex = 999;
                  return _.min([nmIndex, cdIndex])
                });
        } else {
          filteredPortList = [];
        }
  
        let filteredAitportList = [];
        if (_.includes(this.itemTypes, 'air')) {
          filteredAitportList = _.map(_.filter(this.cntryLocations.airport,
                    (airport) => {
                      if (keyword.length <= 0) return true;
                      else if (_.upperCase(airport.portNm).indexOf(keyword) >= 0) return true;
                      else if (_.upperCase(airport.portCd).indexOf(keyword) >= 0) return true;
                      else return false;
                    }));
  
          filteredAitportList = _.sortBy(filteredAitportList,
                  (airport) => {
                    let nmIndex = _.upperCase(airport.portNm).indexOf(keyword);
                    let cdIndex = _.upperCase(airport.portCd).indexOf(keyword);
                    if (nmIndex < 0) nmIndex = 999;
                    if (cdIndex < 0) cdIndex = 999;
                    return _.min([nmIndex, cdIndex])
                  });
        } else {
          filteredAitportList = [];
        }

        let filteredCityList = [];
        if (_.includes(this.itemTypes, 'city')) {
          filteredCityList = _.map(_.filter(this.cntryLocations.city,
                    (city) => {
                      if (keyword.length <= 0) return true;
                      else if (_.upperCase(city.name).indexOf(keyword) >= 0) return true;
                      else if (_.upperCase(city.cityCd).indexOf(keyword) >= 0) return true;
                      else return false;
                    }));
  
          filteredCityList = _.sortBy(filteredCityList,
                  (city) => {
                    let nmIndex = _.upperCase(city.name).indexOf(keyword);
                    let cdIndex = _.upperCase(city.cityCd).indexOf(keyword);
                    if (nmIndex < 0) nmIndex = 999;
                    if (cdIndex < 0) cdIndex = 999;
                    return _.min([nmIndex, cdIndex])
                  });
        } else {
          filteredCityList = [];
        }
        
        if(this._cnsltnQuotRoute.typeCd == NodeType.DOOR || this._cnsltnQuotRoute.typeCd == NodeType.RAIL ){
            this.filteredPortAirCity = filteredCityList;
        }else if(this._cnsltnQuotRoute.typeCd == NodeType.PORT){
            this.filteredPortAirCity = filteredPortList;
        }else if(this._cnsltnQuotRoute.typeCd == NodeType.AIRPORT){
            this.filteredPortAirCity = filteredAitportList;
        }
      }
    }

    onOceanLineInput(event) {
      let val = "";
      if(event && event.target) val = event.target.value;
      else val = event;

      if (!val) {
        if (this.selectedOceanLine) this.selectedOceanLine = null;
        this.isOceanLineListOpen = false;
        this._cnsltnQuotRoute.linerNm = '';
        this._cnsltnQuotRoute.linerCd = '';
        return;
      }
  
      if(val.length < 2) {
        this.isOceanLineListOpen = false;
        this._cnsltnQuotRoute.linerNm = val;
        this._cnsltnQuotRoute.linerCd = '';
      } else {
        this.isOceanLineListOpen = true;
        let keyword = _.trim(_.upperCase(val));

        if(!this._cnsltnQuotRoute.oceanLines){
          this._cnsltnQuotRoute.oceanLines = this.oceanLineService.lineList;
        }

        
        let filteredOceanLineList = [];
        if (_.includes(this.itemTypes, 'port')) {
          filteredOceanLineList = _.map(_.filter(this._cnsltnQuotRoute.oceanLines,
                    (oceanLine:OceanLine) => {
                      if (keyword.length <= 0) return true;
                      else if (_.upperCase(oceanLine.lineNm).indexOf(keyword) >= 0) return true;
                      else if (_.upperCase(oceanLine.lineCd).indexOf(keyword) >= 0) return true;
                      else return false;
                    }));
  
          filteredOceanLineList = _.sortBy(filteredOceanLineList,
                (oceanLine) => {
                  let nmIndex = _.upperCase(oceanLine.lineNm).indexOf(keyword);
                  let cdIndex = _.upperCase(oceanLine.lineCd).indexOf(keyword);
                  if (nmIndex < 0) nmIndex = 999;
                  if (cdIndex < 0) cdIndex = 999;
                  return _.min([nmIndex, cdIndex])
                });
        } else {
          filteredOceanLineList = [];
        }

        this.filteredOceanLineList = filteredOceanLineList;

        if(filteredOceanLineList.length < 1){
          this._cnsltnQuotRoute.linerNm = val;
          this._cnsltnQuotRoute.linerCd = '';
        }
      }

      this._cnsltnQuotRoute.linerNm = val;
      // this._cnsltnQuotRoute.linerCd = '';
    }

    onAirLineInput(event) {

      let val = "";
      if(event && event.target) val = event.target.value;
      else val = event;

      if (!val) {
        if (this.selectedAirLine) this.selectedAirLine = null;
        this.isAirLineListOpen = false;
        this._cnsltnQuotRoute.linerNm = '';
        this._cnsltnQuotRoute.linerCd = '';
        return;
      }
      if(!val && val.length < 2) {
        this.isAirLineListOpen = false;
        this._cnsltnQuotRoute.linerNm = val;
        this._cnsltnQuotRoute.linerCd = '';
      } else {
        this.isAirLineListOpen = true;
        let keyword = _.trim(_.upperCase(val));

        if(!this._cnsltnQuotRoute.airLines){
          this._cnsltnQuotRoute.airLines = this.airLineService.lineList;
        }
  
        let filteredAirLineList = [];
        if (_.includes(this.itemTypes, 'air')) {
          filteredAirLineList = _.map(_.filter(this._cnsltnQuotRoute.airLines,
                    (airLine:AirLine) => {
                      if (keyword.length <= 0) return true;
                      else if (_.upperCase(airLine.name).indexOf(keyword) >= 0) return true;
                      else if (_.upperCase(airLine.lineCd).indexOf(keyword) >= 0) return true;
                      else if (_.upperCase(airLine.iataCd).indexOf(keyword) >= 0) return true;
                      else return false;
                    }));
  
          filteredAirLineList = _.sortBy(filteredAirLineList,
                  (airLine:AirLine) => {
                    let nmIndex = _.upperCase(airLine.name).indexOf(keyword);
                    let cdIndex = _.upperCase(airLine.lineCd).indexOf(keyword);
                    if (nmIndex < 0) nmIndex = 999;
                    if (cdIndex < 0) cdIndex = 999;
                    return _.min([nmIndex, cdIndex])
                  });
        } else {
          filteredAirLineList = [];
        }

        this.filteredAirLineList = filteredAirLineList;

        if(filteredAirLineList.length < 1){
          this._cnsltnQuotRoute.linerNm = val;
          this._cnsltnQuotRoute.linerCd = '';
        }
      }
      this._cnsltnQuotRoute.linerNm = val;
    }
  
    cntryListSelectHandler(cntry) {
      this.focusedCntryIndex = 0;
      this.isCntryListOpen = false;
      this.selectedCntry = cntry;
      
      this._cnsltnQuotRoute.cntryCd = cntry.cntryCd;
      this._cnsltnQuotRoute.location.cntryNm = cntry.cntryNm;
      this._cnsltnQuotRoute.location.cntryCd = cntry.cntryCd;
      this.mapOptions.componentRestrictions = {country: this.selectedCntry.cntryCd};
      
      this.countryControl.setValue(this.selectedCntry.cntryNm);
  
      this.cntryLocations.city = new Array<City>();
      this.cntryLocations.port = new Array<Port>();
      this.cntryLocations.airport = new Array<Airport>();
      
      this.cityService.getCities(this.selectedCntry.cntryCd).subscribe(
          data => this.cntryLocations.city = data,
          err => console.log("Error code: %s, URL: %s", err.status, err.url)
      );
  
      let filteredPorts = _.filter(this.ports, {'cntryCd' : this.selectedCntry.cntryCd});
      this.cntryLocations.port = filteredPorts;
  
      let filteredAirports = _.filter(this.airports, {'cntryCd' : this.selectedCntry.cntryCd});
      this.cntryLocations.airport = filteredAirports;
      
      if(this._cnsltnQuotRoute.typeCd == NodeType.DOOR) this.setAutoComplete();

      //항만/항공/도시 셋팅
      if(this._cnsltnQuotRoute.location && this._cnsltnQuotRoute.location.name){
        this.onPortAirCityInput(this._cnsltnQuotRoute.location.name);
        if(this.filteredPortAirCity.length > 0){
          this.locationListSelectHandler(this.filteredPortAirCity[0]);
        }
      }
    }
  
    locationListSelectHandler(location) {
      this.focusedLocationIndex = 0;
      this.isPortCityListOpen = false;
      this.selectedLocation = location;
      this.portAirCityControl.setValue(location.name);
      this._cnsltnQuotRoute.location.name = location.name;
      if(location.type === 'city') {
        //this.setAutoComplete();
        this._cnsltnQuotRoute.locationAdrs = ""; 
      }else{
        this._cnsltnQuotRoute.latitude = this.selectedLocation.latitude;
        this._cnsltnQuotRoute.longitude = this.selectedLocation.longitude;
      }

      this._cnsltnQuotRoute.cntryCd = location.cntryCd;
      this._cnsltnQuotRoute.location.locationId = this.selectedLocation.locationId;

    }

    airLineListSelectHandler(airLine:AirLine) {
      this.focusedAirLineIndex = 0;
      this.isAirLineListOpen = false;
      this.selectedAirLine = airLine;
      this.airLineControl.setValue(airLine.lineCd);
      this._cnsltnQuotRoute.linerCd = airLine.lineCd;
      this._cnsltnQuotRoute.linerNm = airLine.name;
    }

    oceanLineListSelectHandler(oceanLine:OceanLine) {
      this.focusedOceanLineIndex = 0;
      this.isOceanLineListOpen = false;
      this.selectedOceanLine = oceanLine;
      this.oceanLineControl.setValue(oceanLine.lineCd);
      this._cnsltnQuotRoute.linerCd = oceanLine.lineCd;
      this._cnsltnQuotRoute.linerNm = oceanLine.lineNm;
    }
    
    hideCountryList() {
      this.isCntryListOpen = false;
    }
  
    handleKeyDown(event) {
        if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;
  
        let suggestListDom = null;
        let focusedIndex = null;
        let type = null;
    
        if (event.target === this.countryElRef.nativeElement ) {
            type = 'cntry';
            suggestListDom = this.countryListElRef.nativeElement;
            focusedIndex = this.focusedCntryIndex;
        } else if (event.target === this.portAirCityElRef.nativeElement ) {
            type = 'city';
            suggestListDom = this.portAirCityListElRef.nativeElement;
            focusedIndex = this.focusedLocationIndex;
        } else if (event.target === this.oceanLineElRef.nativeElement){
            type = 'oceanLine';
            suggestListDom = this.oceanLineListElRef.nativeElement;
            focusedIndex = this.focusedOceanLineIndex;

        } else if (event.target === this.airLineElRef.nativeElement){
            type = 'airLine';
            suggestListDom = this.airLineListElRef.nativeElement;
            focusedIndex = this.focusedAirLineIndex;
        }
      
        let suggestListItem = null;
        if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');

        switch (event.keyCode) {
            case 13: // enter
                if (type === 'cntry') {
                  if (_.isEmpty(this.filteredCountryList) || !this.focusedCntryIndex == null || !this.isCntryListOpen) return;
                  let item = this.filteredCountryList[this.focusedCntryIndex];
                  this.cntryListSelectHandler(item);
                  this.isCntryListOpen = false;
                } else if (type === 'city') {
                  if (_.isEmpty(this.filteredPortAirCity) || !this.focusedLocationIndex == null || !this.isPortCityListOpen) return;
                  let item = this.filteredPortAirCity[this.focusedLocationIndex];
                  this.locationListSelectHandler(item);
                  this.isPortCityListOpen = false;
                } else if (type == 'oceanLine'){
                  if (_.isEmpty(this.filteredOceanLineList) || !this.focusedOceanLineIndex == null || !this.isOceanLineListOpen) return;
                  let item = this.filteredOceanLineList[this.focusedOceanLineIndex];
                  this.oceanLineListSelectHandler(item);
                  this.isOceanLineListOpen = false;
                } else if (type == 'airLine'){
                  if (_.isEmpty(this.filteredAirLineList) || !this.focusedAirLineIndex == null || !this.isAirLineListOpen) return;
                  let item = this.filteredAirLineList[this.focusedAirLineIndex];
                  this.airLineListSelectHandler(item);
                  this.isAirLineListOpen = false;
                }
                break;
            case 27: // escape
                this.isCntryListOpen = false;
                this.isPortCityListOpen = false;
                this.isOceanLineListOpen = false;
                this.isAirLineListOpen = false;
        
                if (type === 'cntry') {
                    if (this.selectedCntry) this.countryControl.setValue(this.selectedCntry.cntryNm);
                } else if (type === 'city'){
                    if (this.selectedLocation) this.portAirCityControl.setValue(this.selectedLocation.name);
                } else if (type === 'oceanLine'){
                  if (this.selectedLocation) this.oceanLineControl.setValue(this.selectedOceanLine.lineCd);
                } else if (type === 'airLine'){
                  if (this.selectedLocation) this.airLineControl.setValue(this.selectedAirLine.lineCd);
                }
                break;
            case 38: // up
                focusedIndex--;
                if (focusedIndex < 0) focusedIndex = 0;
                suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
                break;
            case 40: // down
                focusedIndex++;
                if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
                suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
            break;
                default: return;
        }
        
        if (type === 'cntry') {
            if (focusedIndex != this.focusedCntryIndex) this.focusedCntryIndex = focusedIndex;
        } else if (type === 'city') {
            if (focusedIndex != this.focusedLocationIndex) this.focusedLocationIndex = focusedIndex;
        } else if (type === 'oceanLine') {
            if (focusedIndex != this.focusedOceanLineIndex) this.focusedOceanLineIndex = focusedIndex;
        } else if (type === 'airLine') {
            if (focusedIndex != this.focusedAirLineIndex) this.focusedAirLineIndex = focusedIndex;
        }
        
        event.preventDefault();
    }
  
    handleCntryBlur($event) {
      this.focusedCntryIndex = 0;
      if (this.isCntryListOpen) this.isCntryListOpen = false;
  
      if (this.selectedCntry && $event.target.value) {
        this.countryControl.setValue(this.selectedCntry.cntryNm);
      }
    }
  
    handleLocationBlur($event) {
      this.focusedLocationIndex = 0;
      if (this.isPortCityListOpen) this.isPortCityListOpen = false;

      if (this.selectedLocation && $event.target.value) {
        this.portAirCityControl.setValue(this.selectedLocation.name);
      }
    }

    handleOceanBlur($event){
      this.focusedOceanLineIndex = 0;
      if (this.isOceanLineListOpen) this.isOceanLineListOpen = false;
          if (this.selectedOceanLine && $event.target.value) {
            this.oceanLineControl.setValue(this.selectedOceanLine.lineCd);
      }
    }

    handleAirBlur($event){
      this.focusedAirLineIndex = 0;
      if (this.isAirLineListOpen) this.isAirLineListOpen = false;
          if (this.selectedAirLine && $event.target.value) {
            this.airLineControl.setValue(this.selectedAirLine.lineCd);
      }
    }
  
    addressHandler(event) {
      // (!event.target.value) this.onAddressSelect.emit(null);
    }

}


// WEBPACK FOOTER //
// ./src/app/containers/fare/rate/detail/fare-rate-detail-route-item.ts